/* "A workout for your cells" — animated supercompensation curve, synced to three plain-language steps. */
(() => {
  const root = document.querySelector("[data-mito]");
  if (!root) return;
  const path = root.querySelector("[data-curve]"), dot = root.querySelector("[data-dot]");
  const marks = [...root.querySelectorAll("[data-mark]")], steps = [...root.querySelectorAll("[data-step]")];
  const reduced = matchMedia("(prefers-reduced-motion: reduce)").matches;
  const L = path.getTotalLength();
  const STOPS = [0.34, 0.62, 1]; // where each step ends along the curve
  const DUR = 9, HOLD = 2.4;
  path.style.strokeDasharray = L; path.style.strokeDashoffset = L;
  let t = 0, last = 0, running = false, raf = 0;

  const render = (p) => {
    path.style.strokeDashoffset = L * (1 - p);
    const pt = path.getPointAtLength(L * p); dot.setAttribute("cx", pt.x); dot.setAttribute("cy", pt.y);
    const active = STOPS.findIndex((s) => p <= s + 1e-6);
    steps.forEach((el, i) => el.setAttribute("aria-current", String(i === (active < 0 ? 2 : active))));
    marks.forEach((m, i) => m.classList.toggle("on", p >= STOPS[i] - (i === 2 ? .02 : .06)));
  };
  const ease = (x) => 1 - Math.pow(1 - x, 3);
  const loop = (ms) => {
    const dt = Math.min(.05, (ms - last) / 1000 || .016); last = ms; t += dt;
    const cyc = t % (DUR + HOLD);
    render(cyc < DUR ? ease(cyc / DUR) : 1);
    if (running) raf = requestAnimationFrame(loop);
  };
  steps.forEach((el, i) => el.addEventListener("click", () => { t = (DUR * [0.18, 0.42, 0.99][i]); }));
  if (reduced) { render(1); return; }
  new IntersectionObserver(([e]) => {
    if (e.isIntersecting && !running) { running = true; t = 0; last = performance.now(); raf = requestAnimationFrame(loop); }
    else if (!e.isIntersecting) { running = false; cancelAnimationFrame(raf); }
  }, { threshold: .3 }).observe(root);
  render(0);
})();
/* domino trigger */
(() => {
  const d = document.querySelector("[data-domino]"); if (!d) return;
  const play = () => { d.classList.remove("go"); void d.offsetWidth; d.classList.add("go"); };
  let timer = 0;
  new IntersectionObserver(([e]) => {
    if (e.isIntersecting) { play(); clearInterval(timer); timer = setInterval(play, 7000); }
    else clearInterval(timer);
  }, { threshold: .45 }).observe(d);
  d.querySelector("[data-replay]")?.addEventListener("click", play);
})();
